import React from 'react';
import styled from '@emotion/styled';

import PlayIcon from '../../../assets/icons/play.svg';
import PauseIcon from '../../../assets/icons/pause.svg';

interface IPlayButton {
  isPlaying?: boolean;
  onClick: () => void;
}

const PlayButton: React.FC<IPlayButton> = ({ isPlaying = false, onClick }) => {
  return (
    <ButtonContainer onClick={onClick}>
      {isPlaying ? <PauseIcon /> : 'Auto Scroll'}
    </ButtonContainer>
  );
};

export default PlayButton;

const ButtonContainer = styled.button`
  width: 50px;
  height: 50px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 0;
  border-radius: 50%;
  background-color: white;
  color: #0a84ff;
  font-size: 11px;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-left: 5px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 840px) {
    margin-top: 0;
    width: 43px;
    height: 43px;
  }
`;
